<div class="invoice-header-container mb-20 mct-flex mct-row mct-justify-between mct-items-center"  >
  <div>
    <wl-profile-type-icon
      [isMember]="profile.Member"
      [isOrg]="profile.OrgInd"
      [profileId]="profile.ProfileId"
      [styleOverrides]="{ 'max-width': '34px', 'max-height': '34px' }"
      class="p-20"
    ></wl-profile-type-icon
    ><strong>{{ profile.ReportName }} ({{ profile.ProfileId }})</strong>
  </div>
  <div class="mct-flex mct-row mct-justify-center mct-items-center mct-gap-5"   >
    <wl-busy [show]="isSaving"></wl-busy>
    <button
      class="btn btn-primary"
      type="button"
      (click)="saveClick()"
      title="{{ 'profiles.new-member-invoice.save' | translate | titlecase }}"
      [disabled]="isSaving"
    >
      {{ 'profiles.new-member-invoice.save' | translate | titlecase }}
    </button>
    <button
      class="btn btn-danger"
      type="button"
      title="{{ 'common.cancel' | translate | titlecase }}"
      [routerLink]="['/profile/' + profileId.toString()]"
    >
      {{ 'common.cancel' | translate | titlecase }}
    </button>
  </div>
</div>

<wl-invoice-builder
  [profileId]="profileId"
  [invoice]="invoiceWithPayment.Invoice"
  [creditCardPayment]="invoiceWithPayment.CreditCardPayment"
  [isNewMemberInvoice]="true"
></wl-invoice-builder>
